// src/app/public-home/ProductPreview.tsx

import * as React from "react";

/* -------------------------------------------------------------------------- */
/* Constants                                                                  */
/* -------------------------------------------------------------------------- */

const PRODUCT_VIDEO_SRC =
  "/media/product/overview-v1.mp4";

const PRODUCT_VIDEO_POSTER =
  "/media/product/overview-poster-v1.webp";

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export function ProductPreview():
React.JSX.Element {
  const videoRef =
    React.useRef<HTMLVideoElement>(
      null,
    );

  const [
    playing,
    setPlaying,
  ] =
    React.useState(
      false,
    );

  const handlePlay =
    async () => {
      const video =
        videoRef.current;

      if (
        !video
      ) {
        return;
      }

      try {
        await video.play();
      } catch {
        // Native controls remain available if browser playback is rejected.
      }
    };

  return (
    <div className="public-product-preview">
      <video
        ref={
          videoRef
        }
        className="public-product-video"
        poster={
          PRODUCT_VIDEO_POSTER
        }
        preload="metadata"
        playsInline
        controls={
          playing
        }
        onPlay={
          () =>
            setPlaying(
              true,
            )
        }
        onPause={
          () =>
            setPlaying(
              false,
            )
        }
        onEnded={
          () =>
            setPlaying(
              false,
            )
        }
      >
        <source
          src={
            PRODUCT_VIDEO_SRC
          }
          type="video/mp4"
        />

        Your browser does not support video playback.
      </video>

      {!playing ? (
        <button
          type="button"
          className="public-video-play"
          aria-label="Play Estatly product overview"
          onClick={
            () =>
              void handlePlay()
          }
        >
          <span
            className="public-video-play-icon"
            aria-hidden="true"
          >
            ▶
          </span>
        </button>
      ) : null}
    </div>
  );
}